import { useEffect, useRef, useState } from "react";

import Guest1Img from "../../assets/images/conversations/ep-59-bhumika-singh-guest.webp";
import Guest2Img from "../../assets/images/conversations/ep-59-supriya-patwardhan-guest.webp";
import Guest3Img from "../../assets/images/conversations/ep-59-anuradda-ganesh-guest.webp";
import ThumbImg  from "../../assets/images/conversations/059.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: wh-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .wh-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  /* ── INNER ── */
  .wh-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO (2-col)
  ══════════════════════════════════════ */
  .wh-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .wh-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }

  /* LEFT */
  .wh-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .wh-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .wh-hero__title.wh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .wh-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .wh-hero__spotify.wh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .wh-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }

  /* RIGHT */
  .wh-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .wh-hero__right.wh-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail wrapper */
  .wh-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .wh-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .wh-yt-thumb:hover img {
    opacity: 0.85;
  }

  /* play button */
  .wh-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease;
    pointer-events: none;
  }
  .wh-yt-thumb__play img {
    width: 40px;
    height: 44px;
    fill: #ffffff;
  }

  /* iframe */
  .wh-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .wh-yt-iframe-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .wh-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .wh-body.wh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .wh-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .wh-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (3 guests)
  ══════════════════════════════════════ */
  .wh-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .wh-guest.wh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .wh-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }

  /* 3-col guest grid */
  .wh-guest__grid {
    display: flex;
    justify-content: center;
    gap: 30px;
  }
  .wh-guest__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    max-width: 445px;
  }
  .wh-guest__photo-bg {
    width: 100%;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .wh-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .wh-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .wh-inner { padding-left: 32px; padding-right: 32px; }
    .wh-hero { padding-top: 32px; padding-bottom: 48px; }
    .wh-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .wh-hero__title { font-size: 24px; }
    .wh-hero__left { gap: 16px; }
    .wh-guest__title { font-size: 24px; margin-bottom: 24px; }
    .wh-guest__grid { gap: 20px; }
    .wh-guest__photo-bg { width: 100%; height: 300px; }
    .wh-guest__name { font-size: 24px; margin-top: 18px; }
    .wh-body__para { font-size: 14px; margin-bottom: 12px; }
    .wh-body { padding-bottom: 48px; }
    .wh-guest { padding-bottom: 48px; }
    .wh-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .wh-inner { padding-left: 16px; padding-right: 16px; }
    .wh-hero { padding-top: 51px; padding-bottom: 30px; }
    .wh-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .wh-hero__left { gap: 30px; }
    .wh-hero__title { font-size: 30px; }
    .wh-body__para { font-size: 16px; margin-bottom: 10px; }
    .wh-guest__title { font-size: 30px; margin-bottom: 20px; }
    .wh-guest__grid { flex-direction: column; gap: 30px; }
    .wh-guest__card { max-width: 100%; align-items: flex-start; }
    .wh-guest__photo-bg { width: 100%; height: 386px; }
    .wh-guest__name { font-size: 24px; text-align: left; margin-top: 14px;}
    .wh-body { padding-bottom: 30px; }
    .wh-guest { padding-bottom: 30px; }
    .wh-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("wh-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "rwcLp9RzXuc";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="wh-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 59 Women Leaders in Hydrogen"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="wh-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 59 Women Leaders in Hydrogen thumbnail" />
      <div className="wh-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="wh-hero">
      <div className="wh-inner">
        <div className="wh-hero__grid">

          {/* LEFT */}
          <div className="wh-hero__left">
            <h1 ref={titleRef} className="wh-hero__title">
              EP 59 | Women Leaders in Hydrogen – India
            </h1>
            <div ref={spotifyRef} className="wh-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4oreF0oMfcz7s74QdWeVnw?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 59 Spotify Player"
              />
            </div>
          </div>

          {/* RIGHT */}
          <div ref={rightRef} className="wh-hero__right">
            <YouTubeEmbed />
          </div>

        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="wh-body">
      <div className="wh-inner">
        <p className="wh-body__para">
          In 2025, hydrogen is a darling of the energy sector. It represents hope for a greener tomorrow and the opportunity to democratize the energy generation industry, allowing any country to generate energy rather than being subject to the tyranny of the hydrocarbon molecule.
        </p>
        <p className="wh-body__para">
          Yet, it is underrepresented by women at the senior level and all levels of management globally.
        </p>
        <p className="wh-body__para">
          The Women Leaders in Hydrogen – India is a platform built to bring women in the industry together as a community to solve some of the critical commercial and scientific hurdles faced by the industry in India.
        </p>
        <p className="wh-body__para">
          With a mission to empower and inspire, in this episode, we are joined by our Co-Chairs: Dr. Anuradda Ganesh, Bhumika Singh, and Supriya Patwardhan.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="wh-guest">
      <div className="wh-inner">
        <h2 className="wh-guest__title">Our Guest</h2>
        <div className="wh-guest__grid">

          <div className="wh-guest__card">
            <div className="wh-guest__photo-bg">
              <img src={Guest1Img} alt="Bhumika Singh" />
            </div>
            <p className="wh-guest__name">Bhumika SINGH</p>
          </div>

          <div className="wh-guest__card">
            <div className="wh-guest__photo-bg">
              <img src={Guest2Img} alt="Supriya Patwardhan" />
            </div>
            <p className="wh-guest__name">Supriya PATWARDHAN</p>
          </div>

          <div className="wh-guest__card">
            <div className="wh-guest__photo-bg">
              <img src={Guest3Img} alt="Anuradda Ganesh" />
            </div>
            <p className="wh-guest__name">Anuradda GANESH</p>
          </div>

        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep59WomenLeadersHydrogen() {
  return (
    <>
      <style>{CSS}</style>
      <div className="wh-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}